import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { pageColors } from "../mock";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

/**
 * Reusable "editorial roundup" page.
 * Renders a header, a lead image, an intro, and an optional grid of
 * outbound-link boxes for the sub-articles.
 */
const ArticlePage = ({
  title,
  subtitle,
  leadImage,
  body,
  sources = [],
  primaryHref,
  primaryLabel,
  hoverColor = pageColors.culture,
}) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = `TMM|${title.toUpperCase()}`;
  }, [title]);

  return (
    <>
      <Header hoverColor={hoverColor} compact={false} />
      <div className="article-page">
        <button className="article-back" onClick={() => navigate("/culture")}>
          <ArrowLeft size={18} /> Back to Culture
        </button>

        <div className="article-hero">
          <img src={leadImage} alt={title} className="article-hero-img" />
          <div className="article-hero-text">
            <div className="article-hero-tag">{subtitle}</div>
            <h1 className="article-hero-title">{title}</h1>
          </div>
        </div>

        <div className="article-body">
          {body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>

        {sources.length > 0 && (
          <div className="article-sources-grid">
            {sources.map((s) => (
              <a
                key={s.href}
                className="source-card"
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ "--accent": s.accent || "#e648ca" }}
              >
                <div className="source-card-swatch" />
                <div className="source-card-body">
                  <div className="source-card-brand">{s.brand}</div>
                  <div className="source-card-title">{s.title}</div>
                  <div className="source-card-cta">
                    Read at {s.host} <ArrowUpRight size={16} />
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}

        {primaryHref && (
          <div className="article-footer">
            <a
              className="article-primary"
              href={primaryHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              {primaryLabel || primaryHref} <ArrowUpRight size={18} />
            </a>
            <p className="article-attribution">
              Content and imagery credit belongs to their respective creators
              and publishers. This roundup only summarises and links out — please
              visit the source pages for the full stories.
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default ArticlePage;
